export default "__VITE_ASSET__4e1534c0__"